/* eslint-disable prettier/prettier */
/* eslint-disable prefer-destructuring */
import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { CorrespondenceRefrenceUserService, DefaultSelection36CorrespondenceReferenceUserPayload } from "@api";

@Injectable({
  providedIn: "root"
})
export default class CreateStepResolver {
  router = inject(Router);
  private correspondenceRefrenceUserService = inject(CorrespondenceRefrenceUserService);


  resolve(): Observable<DefaultSelection36CorrespondenceReferenceUserPayload[]> {
    return this.correspondenceRefrenceUserService.getAllCorrespondenceRefrenceUsers();
  }
}
